import Switch from './routes'

const App = () => {
  return (
    <div className="App">
      <Switch />
    </div>
  )
}

export default App
